class SpotlightGameModel {
  constructor (data, params) {
      this.players = data?.players || [];
      this.params = params;
  }
}

export default SpotlightGameModel;
